<input [placeholder]="placeholder" [(ngModel)]="value" />
